import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class InclusionThemesAPI extends API {
	getThemesBySessionStatus(session, status) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion/${session}/${status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getTopic(topic) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${topic}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	enviarNotificacionResponsable(id_tema, estatus, userName) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/setEstatus/${id_tema}/${estatus}?userName=${userName}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	eliminarTema(id_tema) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/setEstatus/${id_tema}/E`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getIssuesBySessionId(organo) {
		//Por modificaciones el backend espera idorgano y ya no idsession
		const status = 'AC';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion/${organo}/${status}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getIssuesByOrder(order) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener-por-orden-dia?ordenDia=${order}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const inclusionThemesAPI = new InclusionThemesAPI('/inclusion_temas');
